export var changeMainPageFileAction = function (name, type, url, status, hasData) {
    return {
        type: "changeMainPageFile",
        payload: {
            name: name,
            type: type,
            url: url,
            status: status,
            hasData: hasData,
        },
    };
};
export var outputMsg = function (desc) {
    return {
        type: "outputMsg",
        payload: desc,
    };
};
